import React, { useEffect, useState } from 'react'
import { applyPromoCode, removePromoCode } from '../../services/api'

function PromoCode({
  showPromoBox,
  promoDiscount,
  setPromoDiscount,
  promoCode,
  setPromoCode,
  setNewTotal,
  message,
  setMessage,
  setRoundUpAmount,
  isAnExchange
}) {
  const defaultPlaceholder = 'Enter Promo Code'
  const [code, setCode] = useState('')
  const [placeholder, setPlaceholder] = useState(defaultPlaceholder)
  const [alert, setAlert] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [removePromoError, setRemovePromoError] = useState(false)

  const cannotApplyError = 'Invalid promo code. (Cannot apply)'
  const invalidError = 'Invalid promo code.'
  useEffect(() => {
    if (promoCode === 'INVALID') {
      removePromoCode().finally(() => {
        setAlert(invalidError)
      })
    } else if (promoCode && promoDiscount == 0) {
      setAlert(cannotApplyError)
    }
  }, [promoCode, promoDiscount])

  const onSubmitPromoCode = async e => {
    e.preventDefault()
    if (isLoading || code === '') {
      return
    } else {
      setIsLoading(true)
      // Use this to disable the "Checkout" buttons when the promo code is being applied.
      window.dispatchEvent(new Event('promo-action-started'))
    }

    let newCart
    // reset alert in case user previously entered an invalid promo
    setAlert('')
    newCart = await applyPromoCode(code)
    if (newCart['error']) {
      // applyPromoCode call will return error message if the promo code is not valid
      setAlert(newCart['error'])
    } else if (newCart['promotionalDiscount'] === 0) {
      // in some cases, the promo code applies but there is no discount
      // show error but keep promo code applied
      setAlert(cannotApplyError)
      setPromoDiscount(newCart['promotionalDiscount'].toFixed(2))
    } else {
      setMessage(newCart['promoMessaging'])
      setPromoDiscount(newCart['promotionalDiscount'].toFixed(2))
      setPromoCode(newCart['promotionalCodeValue'])
      setNewTotal(newCart['total'].toFixed(2))
      setRoundUpAmount(newCart['roundUp'].toFixed(2))
    }
    setCode('')
    setPlaceholder(defaultPlaceholder)
    setIsLoading(false)
    // Use this to re-enable the "Checkout" buttons when the promo code is being applied.
    window.dispatchEvent(new Event('promo-action-ended'))
  }

  const onRemovePromoCode = async () => {
    if (isLoading) {
      return
    } else {
      window.dispatchEvent(new Event('promo-action-started'))
      setIsLoading(true)
    }

    try {
      let newCart = await removePromoCode()

      if (newCart.error === undefined) {
        setMessage(null)
        setPromoDiscount(newCart['promotionalCodeDiscount'])
        setPromoCode(newCart['promotionalCodeValue'])
        setNewTotal(newCart['total'].toFixed(2))
        setRoundUpAmount(newCart['roundUp'].toFixed(2))
        setIsLoading(false)
        window.dispatchEvent(new Event('promo-action-ended'))
      }
    } catch {
      setRemovePromoError(true)
      setMessage(null)
      setIsLoading(false)
      window.dispatchEvent(new Event('promo-action-ended'))
    }
  }

  const onCodeChange = e => {
    const regex = /^[A-Za-z0-9]$/g
    let input = e.target.value
    // prevent users from typing in special characters
    if (input.length > 0 && !input.slice(-1).match(regex)) {
      input = code.replace(input.slice(-1), '')
    } else {
      // if user pastes a promo code with special characters, remove them
      input = input
        .split('')
        .filter(x => x.match(regex))
        .join('')
    }
    setCode(input)
  }

  if (promoDiscount < 0) {
    return (
      <div>
        {removePromoError && (
          <span
            data-testid="remove-promo-error"
            className="font-bold text-14 text-red m-0 mb-12"
          >
            *An error has occurred and your cart has been cleared. Click{' '}
            <a href="/cart">here</a> to restart.
          </span>
        )}
        {message && (
          <span
            data-testid="promo-message"
            className="text-14 text-callout mt-16 mb-0"
          >
            *{message}{' '}
          </span>
        )}
        {showPromoBox && !removePromoError && (
          <span
            data-testid="remove-promo-code"
            onClick={onRemovePromoCode}
            className={
              isLoading
                ? 'mt-4 text-14 cursor-not-allowed -disabled'
                : 'mt-4 text-depths text-14 underline cursor-pointer'
            }
          >
            Remove promo code.
          </span>
        )}
      </div>
    )
  } else if (showPromoBox && !isAnExchange) {
    return (
      <form
        data-testid="promo-code-input"
        onSubmit={onSubmitPromoCode}
      >
        <div className="flex flex-wrap">
          <label className="text-16 mb-12 mt-16 w-full">Promo Code</label>
          <p className="font-bold xs-paragraph text-red m-0 mb-12">{alert}</p>
          <div className="block w-full">
            <input
              type="text"
              placeholder={placeholder}
              onChange={onCodeChange}
              value={code}
              className="w-full mb-10"
              name="promo-code"
            />
            <button
              className={
                isLoading
                  ? 'button -dark w-full -disabled'
                  : 'button -dark w-full'
              }
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    )
  } else {
    return null
  }
}

export default PromoCode
